/**
 * `all` nosi PRAZAN opseg, i to je njegova svrha: registar koji se otvara na period skraćuje i
 * pretragu, pa prijemnica iz 2022. ne bi bila nađena dok se period ne promeni. Spisku se nudi samo
 * tamo gde ekran to traži (`allowAll`), da se podrazumevano ponašanje ostalih ekrana ne menja.
 */
export type PeriodPreset = "thisMonth" | "lastMonth" | "thisQuarter" | "ytd" | "last12m" | "custom" | "all";

const iso = (d: Date) => d.toISOString().slice(0, 10);

// Build a UTC-midnight Date for a given calendar year/month/day so that
// toISOString always returns the intended calendar date regardless of
// the host machine's local timezone.
const utc = (y: number, m: number, d: number) => new Date(Date.UTC(y, m, d));

/** Map a preset to a [from,to] ISO date range relative to `now`. */
export function presetRange(preset: PeriodPreset, now = new Date()): { from: string; to: string } {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const today = iso(now);
  switch (preset) {
    case "all":
      return { from: "", to: "" };
    case "thisMonth":
      return { from: iso(utc(y, m, 1)), to: today };
    case "lastMonth":
      return { from: iso(utc(y, m - 1, 1)), to: iso(utc(y, m, 0)) };
    case "thisQuarter": {
      const qStart = Math.floor(m / 3) * 3;
      return { from: iso(utc(y, qStart, 1)), to: today };
    }
    case "ytd":
      return { from: iso(utc(y, 0, 1)), to: today };
    case "last12m":
      return { from: iso(utc(y - 1, m, now.getUTCDate())), to: today };
    case "custom":
    default:
      return { from: iso(utc(y, 0, 1)), to: today };
  }
}
